<template>
    <transition-group name="slide-fade">
        <div class="promo-code-box" key="input">
            <div class="fields input" v-if="this.promo || display">
                <input type="text" @keyup.enter="apply" id="promoCodeInput" :placeholder="this.$parent.locale.text_promo_placeholder" name="promoCodeInput" v-model="promo"/>
                <input type="submit" @click="apply" class="cta-button blue" id="promoCodeApply" :value="this.$parent.locale.button_promo_submit" />
            </div>
            <div class="promo-code-reveal" v-else>
                <span><a @click="display=true" class="">Click here if you have a promo code</a></span>
            </div>
        </div>
        <div class="box-layout-inner alert" key="alert" v-if="box.show">
            <div class="full-width" :class="box.colour">
                <span v-html="box.message"></span>
            </div>
        </div>
    </transition-group>

</template>

<script>
    export default {
        data () {
            return {
                promo: '',

                display: true,

                box: {
                    show: false,
                    colour: 'red',
                    message: "",
                },
            }
        },
        props: [ 'booking_id', 'existing_code' ],
        created () {
            this.promo = this.existing_code;
        },
        methods: {
            apply: function () {
                //Only want to submit if there is a promo code entered
//                if(!this.promo)
//                    return false;

                axios.post('camp-booking/bookings/' + this.booking_id + '/promocode', {
                    promocode: this.promo
                }).then(response => {
                    if(response.data.data.state == 'Invalid') {
                        //Handle invalid response here
                        this.box = { show: true, message: this.$parent.locale.text_promo_submit_failed, colour: 'red'}
                    } else if(response.data.data.state == 'Superseded') {
                        //Handle superseded response here
                        this.box = { show: true, message: this.$parent.locale.text_promo_submit_superseded, colour: 'red'}
                    } else {
                        //Handle valid response here
                        this.box = { show: true, message: this.$parent.locale.text_promo_submit_success, colour: 'green'}
                        this.$emit('appliedpromo');
                    }

                    setTimeout(() => {
                        this.box = { show: false, message: '', colour: '' }
                    }, 3000)
                })

            }
        },
    }
</script>



// WEBPACK FOOTER //
// BasketPromo.vue?eed67314